import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
    >
      <div className="w-full sm:w-48 h-32 flex-shrink-0 overflow-hidden rounded-lg bg-background-100">
        <img
          src={article.image}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
          {article.summary}
        </p>
        <div className="flex items-center gap-4 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views.toLocaleString()} 阅读
          </span>
          <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs">
            {article.category}
          </span>
        </div>
      </div>
    </Link>
  );
}